import SideBar from "@/views/Dashboard/Layout/SideBar/SideBar.vue";

const SidebarStore = {
  showSidebar: false,
  sidebarLinks: {},
  displaySidebar (value) {
    this.showSidebar = value
  }
}

const SidebarPlugin = {
  install (Vue) {
    Vue.mixin({
      data () {
        return {
          sidebarStore: SidebarStore
        }
      }
    })

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get () {
        return this.$root.sidebarStore
      }
    })
    Vue.component('SideBar', SideBar)
  }
}

export default SidebarPlugin
